import { initializeApp } from 'firebase/app';
import {
    getFirestore, collection, getDocs, query, orderBy, addDoc, Timestamp, deleteDoc,
    doc, where
} from 'firebase/firestore';

// Firebase configuration
// const firebaseConfig = {
//     apiKey: "YOUR_API_KEY",
//     authDomain: "YOUR_AUTH_DOMAIN",
//     projectId: "YOUR_PROJECT_ID",
//     storageBucket: "YOUR_STORAGE_BUCKET",
//     messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
//     appId: "YOUR_APP_ID",
// };

const firebaseConfig = {
    apiKey: "AIzaSyALil3QvEc4GDpQCHcV-hG3-evAUnrSeVA",
    authDomain: "mockmcontact.firebaseapp.com",
    projectId: "mockmcontact",
    storageBucket: "mockmcontact.firebasestorage.app",
    messagingSenderId: "175500637478",
    appId: "1:175500637478:web:8d1ada4b1ddf255919bde7",
    measurementId: "G-HC0Y5GLXHP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {
    db, collection, getDocs, query, orderBy, addDoc, Timestamp,
    deleteDoc,
    doc, where
};
